import { useDisableLocationSelection } from '@/hooks/useDisableLocationSelection';
import { PageContainer } from '../components/core/PageContainer';
import { Title } from '../components/core/Title';
import { HiMiniArrowSmallRight } from "react-icons/hi2";
import { useNavigate } from 'react-router-dom';

export function Policies() {
  const navigate = useNavigate();

  useDisableLocationSelection(true);

  return (
    <PageContainer className="max-w-3xl" scrollable>
      <Title>Policies & Agreements</Title>

      <div className="mt-6">
        <div
          className="bg-gray-100 rounded-xl py-3 px-4 flex items-center gap-1 cursor-pointer w-full"
          onClick={() => navigate('/privacy-policy')}
        >
          <span className="font-normal">Privacy Policy</span>
          <HiMiniArrowSmallRight className="-rotate-45 w-6 h-6" />
        </div>
      </div>
    </PageContainer>
  );
} 